<script>
import { ArticleTag } from '@/api'
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.ForeignKey({
              label: 'Tagi artykułów',
              modelPath: [this, 'form', 'tags'],
              multiple: true,
              clearable: true,
              required: true,
              service: ArticleTag
            }),
            new fields.ColorSelect({
              label: 'Kolor (domyślnie Podstawowy)',
              modelPath: [this, 'form', 'color']
            })
          ]
        }
      ]
    }
  }
}
</script>
